import { Gauge } from "lucide-react";
import { VITAL_SIGNS_MAP } from "@/lib/vitalsigns-maps.js";
import { VITALSIGN_ICON_BY_API_KEY } from "./optimization-vitals-constants.js";

/**
 * @param {string} apiKey
 * @returns {import("lucide-react").LucideIcon}
 */
export function getVitalSignIcon(apiKey) {
  return VITALSIGN_ICON_BY_API_KEY[apiKey] ?? Gauge;
}

export function formatVitalDisplayValue(v) {
  if (v.value === "" || v.value == null) return "—";
  const num = Number(v.value);
  return Number.isFinite(num) ? num.toFixed(1) : String(v.value);
}

/**
 * @param {unknown[]} vitalSigns
 * @returns {Array<Record<string, unknown>>}
 */
export function getOrderedVitalSigns(vitalSigns) {
  const byApiKey = new Map(vitalSigns.map((v) => [v.name, v]));
  const engineMaxHp = byApiKey.get("engineMaxHp")?.value;
  const hpUsedSubtitle =
    engineMaxHp != null && engineMaxHp !== "" ? `${engineMaxHp} HP used` : null;

  return VITAL_SIGNS_MAP.map(({ apiKey, displayName, unit: defaultUnit }) => {
    const match = byApiKey.get(apiKey);
    const subtitle =
      apiKey === "hpUtilizationPercent" && hpUsedSubtitle
        ? hpUsedSubtitle
        : (match?.subtitle ?? "");
    if (match) {
      return {
        ...match,
        apiKey,
        name: displayName,
        unit: match.unit || defaultUnit,
        subtitle,
      };
    }
    return {
      apiKey,
      name: displayName,
      value: "",
      unit: defaultUnit,
      subtitle,
    };
  });
}
